class AjaxCart {
  static async getCart() {
    return await fetch(`${routes.cart_url}.js`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        return data;
      })
      .catch(err => {
        console.error(err);
      });
  }

  static async getCartItem(key) {
    return await AjaxCart.getCart().then(data => {
      const cartItem = data.items.find(item => item.key === key);
      return cartItem;
    });
  }

  static async addToCart(body, sourse = 'ajax-api') {
    return await fetch(`${routes.cart_add_url}`,  { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.json();
      })
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: sourse,
          productVariantId: data.variant_id,
          cartData: data,
        });
        return data;
      })
      .catch(err => {
        console.error(err);
      });
  }

  static async changeCart(body, sourse = 'ajax-api') {
    const ctas = document.querySelectorAll('#CartDrawer-Checkout, drawer__totals-checkout a');
    if (ctas.length > 0) ctas.forEach(btn => btn.setAttribute('disabled', 'disabled'));
    
    return await fetch(`${routes.cart_change_url}`,  { ...fetchConfig(), ...{ body } })
      .then(response => {
        return response.json();
      })
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: sourse,
          cartData: data,
        });
        return data;
      })
      .catch(err => {
        console.error(err);
      });
  }

  static async cartClear(sourse = 'ajax-api') {
    return await fetch(`${routes.cart_clear_url}.js`, {...fetchConfig()})
      .then(response => response.json())
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: sourse,
          cartData: data,
        });
        return data;
      })
      .catch(err => {
        console.error(err);
      });
  }
}
